<template>
  <Modal :title="staff.id ? 'スタッフ名編集' : '新規スタッフの追加'" :loading="busy" @close="$emit('close')">
    <FormGrid>
      <dt>スタッフ名</dt>
      <dd>
        <TextInput placeholder="スタッフ名" v-model.trim="name" />
      </dd>
    </FormGrid>
    <template #footer-center>
      <Button @click="$emit('close')">戻る</Button>
      <Button primary :disabled="!changed" @click="save">{{ staff.id ? '保存' : '追加' }}</Button>
    </template>
  </Modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { models } from '@/utils/vue'
import Modal from '@/components/molecules/Modal'
import FormGrid from '@/components/molecules/FormGrid'
import Button from '@/components/atoms/Button'
import TextInput from '@/components/atoms/TextInput'

export default {
  name: 'StaffEditModal',
  components: {
    Modal,
    FormGrid,
    Button,
    TextInput,
  },
  computed: {
    ...mapState({
      staff: state => state.staffs.edit.staff,
      busy: state => state.staffs.edit.busy,
    }),
    ...mapGetters({
      changed: 'staffs/edit/changed',
    }),
    ...models(
      ['name'],
      ({ staff }, key) => staff[key],
      ({ $store }, key, value) => $store.commit('staffs/edit/update', { [key]: value }),
    ),
  },
  methods: {
    async save() {
      if (await this.$store.dispatch('staffs/edit/save')) {
        this.$emit('saved')
        this.$emit('close')
      }
    },
  },
}
</script>
